class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.isMobile = this.dataset.mobileSearch === 'true';

    this.cachedResults = {};
    this.isOpen = false;
    this.searchTerm = '';

    this.form = this.querySelector('form');
    this.input = this.form.querySelector('input[type="search"]');  
    
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.input.addEventListener('input', debouncedOnChange.bind(this));
    this.input.addEventListener('focus', this.onChange.bind(this));

    this.addEventListener('focusout', this.handleFocusOut.bind(this));

    this.resultsContainer = this.isMobile
      ? this.querySelector('.drawer-search__middle')
      : this.querySelector('.header__search-products');

    if (this.resultsContainer) {
      this.resultsContainer.addEventListener('mousedown', (e) => e.preventDefault());
      this.resultsContainer.addEventListener('touchstart', (e) => {
        if (e.target.closest('a')) return;
        e.preventDefault();
      });
    }

    if(this.isMobile) {
      this.details = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.closeButton = this.form.querySelector('[data-close-search]');

      this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
      this.summaryToggle.addEventListener('click', this.handleSummaryClick.bind(this));
    }
  }

  handleFocusOut(e) {
    if (!this.contains(e.relatedTarget)) {
      this.close();
    }
  }

  handleCloseClick(e) {
    e.preventDefault();

    this.details.removeAttribute('open');

    this.summaryToggle.setAttribute('aria-expanded', false);
    this.summaryToggle.focus();
  }

  handleSummaryClick(e) {
    this.form.classList.add("hidden");

    setTimeout(() => {
      this.form.classList.remove("hidden");
      this.input.focus()
    }, 100);
  }

  close() {
    if(this.isMobile) {
      this.querySelector('.drawer-search__middle').innerHTML = '';
    } else {
      this.querySelector('.header__search-products').innerHTML = '';
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    this.searchTerm = newSearchTerm;

    if (!newSearchTerm.length) {
      this.searchTerm = '*';
    }

    this.getSearchResults();
  }

  getSearchResults() {
    this.setLiveRegionLoadingState();

    const queryKey = this.searchTerm.replace(' ', '-').toLowerCase();    

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=${this.isMobile ? 'predictive-search_mobile' : 'predictive-search_desktop'}&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#PredictiveSearchResults');
        
        this.cachedResults[queryKey] = resultsMarkup;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.removeAttribute('loading');

    if(this.isMobile) {
      this.querySelector('.drawer-search__middle').innerHTML = resultsMarkup.innerHTML;
    } else {
      this.querySelector('.header__search-products').innerHTML = resultsMarkup.innerHTML;
    }
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
}

customElements.define('predictive-search', PredictiveSearch);
